import Splide from '@splidejs/splide';

export const sliders = () => {

  var elms = document.getElementsByClassName( 'splide' );
  for ( var i = 0; i < elms.length; i++ ) {

    var main = false;
    var thumbnails = false;

    if (!elms[ i ].classList.contains('thumbnails')) {
      main = new Splide( elms[ i ], {
        pagination: false,
        arrows: false,
      } );

      if (elms[i].attributes['data-sync']) {
        thumbnails = new Splide(elms[i].attributes['data-sync'].nodeValue, {
          rewind          : true,
          fixedWidth      : 104,
          fixedHeight     : 58,
          isNavigation    : true,
          gap             : 10,
          focus           : 'center',
          pagination      : false,
          cover           : true,
          dragMinThreshold: {
            mouse: 4,
            touch: 10,
          },
          breakpoints : {
            640: {
              fixedWidth  : 66,
              fixedHeight : 38,
            },
          },
        });
      }

      if (thumbnails) {
        main.sync( thumbnails );
      }

      main.mount();

      if (thumbnails) {
        thumbnails.mount();
      }

    }

  }

}
